import { render } from "./adminPermisos-Component.vue?vue&type=template&id=6a34bd28&scoped=true"
import script from "./adminPermisos-Component.vue?vue&type=script&lang=js"
export * from "./adminPermisos-Component.vue?vue&type=script&lang=js"

import "./adminPermisos-Component.vue?vue&type=style&index=0&id=6a34bd28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a34bd28"]])

export default __exports__